import { AdminComponentComponent } from './admin-component.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddCompteServerComponent } from './add-compte-server/add-compte-server.component';
import { CompteDetailsComponent } from './compte-details/compte-details.component';
import { ComptesServerComponent } from './comptes-server/comptes-server.component';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ArchiveComponent } from './archive/archive.component';
import { BrowserModule } from '@angular/platform-browser';


/**
 * created by AHMED HAYEL
 * 
 */

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: AdminComponentComponent,
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full'
          },
          {
            path: 'dashboard',
            component: DashboardComponent
          },
          {
            path: 'compteDetails/:idCompteClientServer',
            component: CompteDetailsComponent
          },
          {
            path: 'addServer',
            component: AddCompteServerComponent
          },
          {
            path: 'listServer',
            component: ComptesServerComponent
          },{
            path: 'archiveBoitier/:numBoitier',
            component: ArchiveComponent
          }
          
        ]
      }

    ])
  ],

  exports: [
    RouterModule
  ]
})
export class AdminComponentRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/admin-component/admin-component-routing.module.ts